export default [
  { value: 'daily', label: 'ui-erm-usage.settings.harvester.config.periodic.interval.daily' },
  { value: 'weekly', label: 'ui-erm-usage.settings.harvester.config.periodic.interval.weekly' },
  { value: 'monthly', label: 'ui-erm-usage.settings.harvester.config.periodic.interval.monthly' }
];
